import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Services from '../Home/Services/Services';

const ServiceDetail = () => {
    return (
        <div className='container text-center'> 
            <p>oops! apatoto amader service bondo - so kicudin por abar asben dawat roilo thank you!!!</p>
        </div>
    );
};

export default ServiceDetail;





